module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_0.d5ff7bc7.png";